/* eslint-disable no-console */
import firebase from 'firebase/app'
import 'firebase/firebase-firestore'
import * as constants from '../../../constants.json'

export default {
  /**
   * Properties from the app state.
   * @property {array} state.error        - The error message.
   * @property {object} state.newToolbar  - A boolean to activate the new toolbar
   * @property {object} state.loading     - A boolean to activate the loading animation.
   * @property {object} state.media       - The media array.
   */
  state: {
    error: null,
    newToolbar: null,
    loading: false,
    media: []
  },

  mutations: {

    /**
     * Mutation method to turn the loading animation on or off.
     * @param {*} state    - The state property.
     * @param {boolean} payload  - A boolean, true or false.
     */
    mutationSetLoading (state, payload) {
      state.loading = payload
    },

    /**
     * Mutation method that add the error to state.
     * @param {*} state    - The state property.
     * @param {object} payload  - The error message.
     */
    mutationSetError (state, payload) {
      state.error = payload
    },

    /**
     * Mutation method to clear the error state.
     * @param {*} state    - The state property.
     */
    mutationClearError (state) {
      state.error = null
    },

    /**
     * Mutation method to acivate the new toolbar.
     * @param {*} state    - The state property.
     * @param {object} payload  - A boolean, true or false.
     */
    mutationSetNewToolbar (state, payload) {
      state.newToolbar = payload
    },

    /**
     * Mutation method that add a media object to media state.
     * @param {*} state    - The state property.
     * @param {object} payload  - The media object
     */
    mutationAddMedia (state, payload) {
      state.media.push(payload)
    },

    /**
     * Mutation method that load all media fetched from database to the state.
     * @param {*} state    - The state property.
     * @param {object} payload  - An array of media objects.
     */
    mutationSetMedia (state, payload) {
      state.media = payload
    }
  },

  actions: {
    /**
    * Clear error from state.
    */
    actionClearError ({ commit }) {
      commit('mutationClearError')
    },

    /**
     * Activate the new toolbar.
     * @param {boolean} payload - A boolean, true to activate it, false deactivate it.
     */
    actionSetToolbar ({ commit }, payload) {
      commit('mutationSetNewToolbar', payload)
    },

    /**
    * Add media to firebase storage and the url to database.
    * @param {object} payload  - It has the following properties: companyId, media and videoThumbnail.
    */
    async actionAddMedia ({ commit }, payload) {
      console.log('payload', payload)
      try {
        // Store media on firebase storage and the url to media doc.
        console.log('media is an image')
        await firebase
          .firestore()
          .collection('companies')
          .doc(payload.companyId)
          .collection('bots')
          .doc(constants.BOT_ID)
          .collection('media')
          .add({
            name: payload.fullName,
            url: payload.url,
            type: payload.type
          })

        commit('mutationAddMedia', {
          name: payload.fullName,
          url: payload.url,
          type: payload.type
        })
      } catch (error) {
        throw error
      }
    },

    /**
    * Load media from firestore
    * @param {object} payload - Contains the fallowing properties: companyId.
    */
    async actionLoadMedia ({ commit }, payload) {
      // Loading on
      commit('mutationSetLoading', true)
      try {
        // Get all media docs ordered by name.
        const dataRef = firebase
          .firestore()
          .collection('companies')
          .doc(payload.companyId)
          .collection('bots')
          .doc(constants.BOT_ID)
          .collection('media')
        const queryMedia = await dataRef.orderBy('name').get()
        console.log('queryMedia', queryMedia)

        // Load all media objects to the state.
        const media = []
        if (!queryMedia.empty) {
          queryMedia.docs.forEach(doc => {
            if (doc.data().type === 'video') {
              media.push({
                name: doc.data().name,
                url: doc.data().url,
                type: doc.data().type,
                thumbnail: doc.data().videoThumbnail
              })
            } else {
              media.push({
                name: doc.data().name,
                url: doc.data().url,
                type: doc.data().type
              })
            }
          })
          commit('mutationSetMedia', media)
        } else {
          commit('mutationSetMedia', [])
        }

        console.log('media', media)

        // Loading off
        commit('mutationSetLoading', false)
      } catch (error) {
        commit('mutationSetLoading', false)
        throw error
      }
    }
  },

  getters: {
    /**
     * @returns the error message from the state.
     */
    getError (state) {
      return state.error
    },

    /**
     * @returns the loading state.
     */
    getLoading (state) {
      return state.loading
    },

    /**
     * @returns the newToolbar state.
     */
    getNewToolbar (state) {
      return state.newToolbar
    },

    /**
     * @returns the array of media obejcts from the state.
     */
    getMedia (state) {
      return state.media
    },

    /**
     * @returns a specific media object.
     */
    getSingleMedia (state) {
      return fileName => {
        return state.media.find(media => {
          return media.name === fileName
        })
      }
    }
  }
}
